import { cn } from "@/lib/utils";

interface BotanicalLeafProps {
  className?: string;
  flip?: boolean;
  animate?: boolean;
}

export function BotanicalLeaf({
  className,
  flip = false,
  animate = true,
}: BotanicalLeafProps) {
  return (
    <svg
      aria-hidden
      viewBox="0 0 120 160"
      className={cn(
        animate && "contact-float",
        flip && "scale-x-[-1]",
        className
      )}
      fill="none"
    >
      <path
        d="M60 10C30 40 15 75 20 110C25 130 40 145 60 150C80 145 95 130 100 110C105 75 90 40 60 10Z"
        fill="var(--contact-green)"
        opacity="0.12"
      />
      <path
        d="M60 20V140"
        stroke="var(--contact-green)"
        strokeWidth="2"
        opacity="0.2"
      />
      <path
        d="M60 50C45 55 35 65 30 80M60 80C75 85 85 95 90 110M60 110C50 115 42 125 38 135"
        stroke="var(--contact-green)"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.18"
      />
    </svg>
  );
}
